module.exports = __webpack_public_path__ + "img/color-1.e2c33fa.png";